import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=0b60c3ea&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=0b60c3ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b60c3ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b60c3ea')) {
      api.createRecord('0b60c3ea', component.options)
    } else {
      api.reload('0b60c3ea', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=0b60c3ea&scoped=true&", function () {
      api.rerender('0b60c3ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iFucYBrI3F5P/JS/comp/PopupDialog.vue"
export default component.exports